import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Collapse from 'packages/ui/Collapse';
import SwitchInput from 'packages/ui/SwitchInput';
import PersianNumber from 'packages/ui/PersianNumber';
import CategoriesInput from './CategoriesInput';
import ProvincesInput from './ProvincesInput';

const filtersText = {
  evand_users: 'انتخاب از کاربران ایوند',
  subscribers: 'انتخاب از مشترکین ایوند',
  organization_followers: 'انتخاب از دنبال کنندگان'
};

const extraCategories = [{ id: -1, title: '*کاربران بدون موضوع' }];

const extraProvinces = [{ id: -1, name: '*کاربران بدون استان' }];

const SwitchWrapper = styled('div')`
  padding: 15px 20px;
`;

const FiltersWrapper = styled('div')`
  border-top: 1px solid #eee;
  padding: 15px 20px;
`;

const ItemWrapper = styled('div')`
  background-color: #f9f9f9;
  border-radius: 3px;
  margin-bottom: 10px;
  position: relative;
`;

const Wrapper = styled('div')`
  margin-bottom: 20px;
  position: relative;
`;

function FiltersInput(props) {
  const { extraCategories, extraProvinces, onChange, audience, type } = props;

  const data = audience.find(item => item && item.filter_type === type) || {
    disabled: true,
    filter_type: type,
    filter_params: {
      provinces: [],
      categories: []
    }
  };

  const handleToggle = event => {
    onChange({
      ...data,
      disabled: !event.target.checked
    });
  };

  const handleChangeParam = (name, val) => {
    onChange({
      ...data,
      filter_params: {
        ...data.filter_params,
        [name]: val
      }
    });
  };

  return (
    <ItemWrapper>
      <SwitchWrapper>
        <SwitchInput
          checked={!data.disabled}
          description={filtersText[type]}
          onChange={handleToggle}
        />
      </SwitchWrapper>

      <Collapse show={!data.disabled}>
        <FiltersWrapper>
          <ProvincesInput
            extraOptions={extraProvinces}
            onChange={val => handleChangeParam('provinces', val)}
            value={data.filter_params.provinces}
          />

          <CategoriesInput
            extraOptions={extraCategories}
            onChange={val => handleChangeParam('categories', val)}
            value={data.filter_params.categories}
            type={type}
          />
        </FiltersWrapper>
      </Collapse>
    </ItemWrapper>
  );
}

function Switch(props) {
  const { onChange, type } = props;

  const [checked, setChecked] = useState(props.defaultValue);

  const handleToggle = event => {
    setChecked(event.target.checked);
    onChange({
      disabled: !event.target.checked,
      filter_type: type,
      filter_params: {
        active: event.target.checked
      }
    });
  };

  return (
    <ItemWrapper>
      <SwitchWrapper>
        <SwitchInput checked={checked} description={filtersText[type]} onChange={handleToggle} />
      </SwitchWrapper>
    </ItemWrapper>
  );
}

function getValue(values, filter) {
  if (values.filter(item => item.filter_type === filter).length > 0) {
    return !values.filter(item => item.filter_type === filter)[0].disabled;
  }
  return false;
}

function AudienceInput({ channel, onChange, value, maximumIntendedReceivers }) {
  const audience = value || [];

  const handleChange = data => {
    if (data.disabled) {
      onChange(audience.filter(item => item.filter_type !== data.filter_type));
    } else {
      if (audience.some(item => item.filter_type === data.filter_type)) {
        onChange(audience.map(item => (item.filter_type === data.filter_type ? data : item)));
      } else {
        onChange([...audience, data]);
      }
    }
  };

  return (
    <Wrapper>
      <p>
        حداکثر تعداد دریافت‌کنندگان مجاز: <PersianNumber value={maximumIntendedReceivers} format />
      </p>
      <FiltersInput
        extraCategories={extraCategories}
        extraProvinces={extraProvinces}
        onChange={handleChange}
        audience={audience}
        type="evand_users"
      />

      <FiltersInput
        onChange={handleChange}
        audience={audience}
        extraCategories={extraCategories}
        type="subscribers"
      />

      <Switch
        onChange={handleChange}
        type="organization_followers"
        defaultValue={getValue(audience, 'organization_followers')}
      />
    </Wrapper>
  );
}

AudienceInput.propTypes = {
  channel: PropTypes.oneOf(['email', 'sms']),
  onChange: PropTypes.func.isRequired,
  value: PropTypes.array
};

export default AudienceInput;
